(() => {
  if (customElements.get('lohnr-announcements')) return;
  class LohnrAnnouncements extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.viewport = this.querySelector('.ln-announcements__viewport');
      this.slides = [...this.querySelectorAll('[data-ann-slide]')];
      this.previous = this.querySelector('[data-ann-prev]');
      this.next = this.querySelector('[data-ann-next]');
      this.pauseButton = this.querySelector('[data-ann-pause]');
      const listen = (target,name,callback) => target.addEventListener(name,callback,{signal:this.controller.signal});
      listen(this.previous,'click',() => this.go(this.index - 1,true));
      listen(this.next,'click',() => this.go(this.index + 1,true));
      listen(this.pauseButton,'click',() => {
        this.paused = !this.paused;
        this.pauseButton.setAttribute('aria-pressed',String(this.paused));
        this.pauseButton.setAttribute('aria-label',this.pauseButton.dataset[this.paused ? 'playLabel' : 'pauseLabel']);
        this.pauseButton.querySelector('[data-pause-icon]').toggleAttribute('hidden',this.paused);
        this.pauseButton.querySelector('[data-play-icon]').toggleAttribute('hidden',!this.paused);
        this.schedule();
      });
      listen(this,'mouseenter',() => { this.hovered = true; this.schedule(); });
      listen(this,'mouseleave',() => { this.hovered = false; this.schedule(); });
      listen(this,'focusin',() => this.schedule());
      listen(this,'focusout',() => queueMicrotask(() => this.isConnected && this.schedule()));
      listen(document,'visibilitychange',() => this.schedule());
      listen(this.motion,'change',() => this.schedule());
      listen(document,'lohnr:loyalty-configured',() => this.update());
      listen(document,'shopify:block:select',event => {
        const slide = this.slides.find(node => node.dataset.blockId === event.detail?.blockId);
        if (!slide) return;
        this.editorSelected = true;
        this.go(this.available.indexOf(slide),true);
      });
      listen(document,'shopify:block:deselect',() => { this.editorSelected = false; this.schedule(); });
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    update() {
      const current = this.available?.[this.index];
      this.available = this.slides.filter(slide => slide.dataset.announcementLoyalty !== 'true' || document.documentElement.dataset.lohnrLoyaltyEnabled === 'true');
      this.hidden = !this.available.length;
      const multiple = this.available.length > 1;
      this.previous.hidden = this.next.hidden = !multiple || this.dataset.arrows !== 'true';
      this.pauseButton.hidden = !multiple || this.dataset.autoplay !== 'true' || this.dataset.pause !== 'true';
      this.go(Math.max(0,this.available.indexOf(current)));
    }
    go(index,manual = false) {
      const count = this.available.length;
      this.index = count ? (index + count) % count : 0;
      this.viewport.setAttribute('aria-live',manual ? 'polite' : 'off');
      this.slides.forEach(slide => { slide.hidden = slide !== this.available[this.index]; });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.available.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.editorSelected || this.motion.matches || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => this.go(this.index + 1),Math.max(3000,Number(this.dataset.interval) || 6000));
    }

  }
  customElements.define('lohnr-announcements',LohnrAnnouncements);
})();
